import constants from '../constants';
import {
  getAdobeVisitorId,
  getCustomerId,
  getVisitorId,
  getCountryCode,
  getZipCode,
  getStateCode,
  getCustomerType,
  getPriceSimplificationExperimentIds,
} from '../utils';

/**
 * Returns the BCOM requester based on the window size.
 * @returns {string} The BCOM requester code.
 */
export const getRequester = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth < constants.BREAK_POINTS.SMALL
      ? 'BCOM-BMEW'
      : 'BCOM-NAVAPP';
  }
  return 'BCOM-NAVAPP';
};

/**
 * Retrieves the RCS value from the sessionStorage.
 * @returns {string|null} The RCS value if available, otherwise null.
 */
export const getRCS = () => sessionStorage?.getItem(constants.RCS_KEY) || null;

export const getDefaultConfig = (requester = false) => ({
  productId: -9,
  customerId: getCustomerId(),
  visitorId: getVisitorId(),
  adobeVisitorId: getAdobeVisitorId(),
  countryCode: getCountryCode(),
  zipCode: getZipCode(),
  stateCode: getStateCode(),
  customerType: getCustomerType(),
  rcs: getRCS(),
  timeout: 15000,
  _customerExperiment: getPriceSimplificationExperimentIds(),
  ...(requester && { requester: getRequester() }),
});
